<template>
    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
    <vs-row class="custom-fields-spacing" >
      <vs-col
        vs-w="12"
        class="mb-4 mt-4 "
        v-for="(text, index) in customFieldsArray"
        :key="index"
      >
        <vs-row>
          <label class="font-normal"
            >{{ text.label }}
            <span v-if="text.reqToSendRequest" class="mid-blue">*</span></label
          >
        </vs-row>
        <vs-row v-if="text.type=='dropdown'">
          <vs-select
            v-validate="{ required: text.reqToSendRequest ? true : false }"
            class="selectExample w-full"
            v-model="text.value"
            :name="`${text.label}`"
          >
            <vs-select-item
              :key="i"
              :value="dropdown"
              :text="dropdown"
              v-for="(dropdown, i) in text.dropdownSelectFields"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has(`${text.label}`)"
              >{{ errors.first(`${text.label}`) }}</span
            >
          </vs-select>
        </vs-row>
        <vs-row class="flex flex-col" v-else-if="text.type === 'file'">
          <input
            type="file"
            v-validate="{ required: text.reqToSendRequest ? true : false, size: maxFileSize * 1024 }"
            class="hidden"
            :name="text.label"
            accept=".pdf"
            :ref="`uploadImgInputRef${index}`"
            @change="updateCurrImg($event, index, text)"
          />
          <vs-button
           v-if="!text.selectedFile"
            class="only-border-btn mt-2"
            size="small"
            style="width: 126px"
            v-round
            @click="uploadImgInput(index)"
          >Upload file
          </vs-button>

          <span v-if="text.selectedFile" class="w-10/12 flex justify-between mt-2 items-center">
             <a href="#">{{ text.selectedFile.name }}</a>
             <p  @click="removeFile(index,text)" class="bin-icon-margin">
            <svg  width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.6665 5.79606C1.6665 5.33582 2.0396 4.96273 2.49984 4.96273H17.4998C17.9601 4.96273 18.3332 5.33582 18.3332 5.79606C18.3332 6.2563 17.9601 6.62939 17.4998 6.62939H2.49984C2.0396 6.62939 1.6665 6.2563 1.6665 5.79606Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33317 3.29606C8.11216 3.29606 7.9002 3.38386 7.74392 3.54014C7.58763 3.69642 7.49984 3.90838 7.49984 4.12939V4.96273H12.4998V4.12939C12.4998 3.90838 12.412 3.69642 12.2558 3.54014C12.0995 3.38386 11.8875 3.29606 11.6665 3.29606H8.33317ZM14.1665 4.96273V4.12939C14.1665 3.46635 13.9031 2.83047 13.4343 2.36163C12.9654 1.89279 12.3295 1.62939 11.6665 1.62939H8.33317C7.67013 1.62939 7.03425 1.89279 6.5654 2.36163C6.09656 2.83047 5.83317 3.46635 5.83317 4.12939V4.96273H4.1665C3.70627 4.96273 3.33317 5.33582 3.33317 5.79606V17.4627C3.33317 18.1258 3.59656 18.7617 4.0654 19.2305C4.53424 19.6993 5.17013 19.9627 5.83317 19.9627H14.1665C14.8295 19.9627 15.4654 19.6993 15.9343 19.2305C16.4031 18.7617 16.6665 18.1258 16.6665 17.4627V5.79606C16.6665 5.33582 16.2934 4.96273 15.8332 4.96273H14.1665ZM4.99984 6.62939V17.4627C4.99984 17.6837 5.08763 17.8957 5.24392 18.052C5.4002 18.2083 5.61216 18.2961 5.83317 18.2961H14.1665C14.3875 18.2961 14.5995 18.2083 14.7558 18.052C14.912 17.8957 14.9998 17.6837 14.9998 17.4627V6.62939H4.99984Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33317 9.12939C8.79341 9.12939 9.1665 9.50249 9.1665 9.96273V14.9627C9.1665 15.423 8.79341 15.7961 8.33317 15.7961C7.87293 15.7961 7.49984 15.423 7.49984 14.9627V9.96273C7.49984 9.50249 7.87293 9.12939 8.33317 9.12939Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6665 9.12939C12.1267 9.12939 12.4998 9.50249 12.4998 9.96273V14.9627C12.4998 15.423 12.1267 15.7961 11.6665 15.7961C11.2063 15.7961 10.8332 15.423 10.8332 14.9627V9.96273C10.8332 9.50249 11.2063 9.12939 11.6665 9.12939Z" fill="#757575"></path></svg>
           </p>

          </span>
          <div class="text-danger text-sm pt-1" v-show="errors.has(`${text.label}`)">
            {{ errors.first(`${text.label}`) }}
          </div>
        </vs-row>
        <vs-row v-else-if="text.type === 'currency'">
          <money
            :name="`${text.label}`"
            v-model="text.value"
            class="w-full"
            v-bind="moneyMask"
            v-validate="{ customCurrency:text.reqToSendRequest ? true : false }"
            @input.native="checkForm"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has(`${text.label}`)"
          >{{ errors.first(`${text.label}`) }}
              </span>
        </vs-row>
        <vs-row v-else-if="text.type === 'date'">
          <date-picker
            v-validate="{ required: text.reqToSendRequest ? true : false }"
            :name="`${text.label}`"
            v-model="text.value"
            lang="en"
            type="date"
            placeholder="DD/MM/YYYY"
            class="w-full customdate"
            format="DD/MM/YYYY"
          ></date-picker>
          <span
            class="text-danger text-sm"
            v-show="errors.has(`${text.label}`)"
          >{{ errors.first(`${text.label}`) }}
          </span>
        </vs-row>
        <vs-row v-else>

          <vs-input
            v-validate="{ required: text.reqToSendRequest ? true : false }"
            :type="text.type"
            class="w-full"
            size="large"
            :name="`${text.label}`"
            v-model="text.value"
            @input="checkForm"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has(`${text.label}`)"
            >{{ errors.first(`${text.label}`) }}</span
          >
        </vs-row>
      </vs-col>
    </vs-row>
    </vs-col>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Validator } from "vee-validate";
import { Money } from "v-money";
import DatePicker from "vue2-datepicker";

const dictionary = {
  en: {
    attributes: {
      templateName: "template name",
      linkedAccount: "linked account",
    },
  },
};
Validator.localize(dictionary);
export default {
  components: {Money,DatePicker},
  props: ["isSubmitted", "customFieldsArray"],

  data() {
    return {
      cfFiles: [],
      cf: "",
      moneyMask: {
        thousands: ",",
        prefix: "$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      maxFileSize: process.env.VUE_APP_FILE_MAX_SIZE_MB,
    };
  },
  watch: {
    async isSubmitted(value) {
      this.startValidating();
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    user() {
      return this.$store.state.AppActiveUser;
    },
    partnerId() {
      return this.user.userType === "admin" ? this.user._id : this.user.partnerId;
    },
  },

  created() {
    this.reqTemplateId = this.$route.params.reqTemId;
    Validator.extend("customCurrency", {
      getMessage: (field) => "Currency input is required",
      validate(value) {
        return new Promise(resolve => {
          resolve({
            valid: value <= 0 ? false : !! value,
            data: value > 0 ? undefined : { message: 'Not this value' }
          });
        });
      }
    });
  },

  methods: {
    async startValidating() {
      await this.$validator.validate();
    },
    validateChildForm() {
      return this.$validator.validateAll();
    },

    checkForm() {
      this.$emit("checkForm");
    },
    uploadImgInput(key) {
      this.$refs[`uploadImgInputRef${key}`][0].click();
    },
    updateCurrImg(input, key, fieldRow) {
      let file = input.target.files[0];
      this.customFieldsArray[key].selectedFile = file;
    },
    removeFile(key,fieldRow) {
      if (fieldRow.hasOwnProperty('value') && fieldRow.value.length > 0) {
        fieldRow.value = "";
      }
      this.$refs[`uploadImgInputRef${key}`][0].value = "";

      if (this.customFieldsArray[key].hasOwnProperty("selectedFile") && typeof this.customFieldsArray[key].selectedFile === 'object') {
        this.$delete(this.customFieldsArray[key], 'selectedFile');
      }
      if (this.errors.has(fieldRow.label)) {
        this.errors.remove(fieldRow.label);
      }
    }
  },
};
</script>